<style scoped>
.query-form {
    margin-top: 40px;
}
</style>

<template>
    <div>
        <h1>客户端用户管理</h1>
        <div class="query-form">
            <el-form ref="queryForm" :model="form" label-width="80px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="用户名称">
                            <el-input v-model="form.nickName" clearable />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="用户状态">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>                    
                    </el-col>
                    <el-col :span="8">
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">查询</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div>
            <el-table :data="consoleUserListData" border style="width:100%">
                <el-table-column prop="userId" label="用户ID" width="150"></el-table-column>
                <el-table-column prop="phone" label="手机号码" width="150"></el-table-column>
                <el-table-column prop="avatar" label="头像" width="150"></el-table-column>
                <el-table-column prop="nickName" label="用户名称" width="150"></el-table-column>
                <el-table-column prop="gender" label="性别" :formatter="genderFormatter" width="150"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" width="180"></el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status==1" @click="forbiddenUser(scope.row)" type="text" size="small">禁用</el-button>
                        <el-button v-if="scope.row.status==3" @click="enableUser(scope.row)" type="text" size="small">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="currentPage" :page-size="pageSize" @current-change="pageCurrentChange"
            background layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import app from '@/App.vue';
import {getUserList, forbiddenUser, enableUser} from '@/request/api';
export default {
    data() {
      return {
        options: [{
            value: 1,
            label: '正常'
        }, {
            value: 3,
            label: '禁用'
        }],
        form: {
          nickName: '',
          status: 1
        },
        currentPage: 1,
        pageSize: 10,
        pages: 1,
        total: 0,
        consoleUserListData: [{

        }],
      }
    },
    methods: {
      onSubmit() {
        getUserList({
            nickName: this.form.nickName,
            status: this.form.status,
            page: this.currentPage,
            size: this.pageSize
        }).then(res => {
            var status = res.status;
            var msg = res.msg;
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.$message.success("查询成功");
                var data = res.data;
                this.consoleUserListData = data.list;
                this.currentPage = data.pageNum;
                this.pagea = data.pages;
                this.total = data.total;
            }
        })
      },
      pageCurrentChange(val) {
        this.currentPage = val;
        this.onSubmit()
      },
      forbiddenUser(row) {
        var userId = row.userId;
        var nickName = row.nickName;

        this.$confirm('此操作将禁用该用户, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                forbiddenUser({
                    userIdList: [userId]
                }).then(res => {
                    var status = res.status;
                    var msg = res.msg;
                    if (status === '2') {
                        this.$message.error(msg);
                    } else {  
                        this.$message({
                            type: 'success',
                            message: '禁用成功!'
                        });
                        this.onSubmit();
                    }
                })
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消操作'
            });          
        });
      },
      enableUser(row) {
        var userId = row.userId;
        var accountName = row.accountName;

        this.$confirm('此操作将启用该用户, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                enableUser({
                    userIdList: [userId]
                }).then(res => {
                    var status = res.status;
                    var msg = res.msg;
                    if (status === '2') {
                        this.$message.error(msg);
                    } else {  
                        this.$message({
                            type: 'success',
                            message: '启用成功!'
                        });
                        this.onSubmit();
                    }
                })
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消操作'
            });          
        });
      },
      genderFormatter(data) {
          if (data.gender === 0) {
              return '初始';
          }
          if (data.gender === 1) {
              return '男';
          }
          if (data.gender === 2) {
              return '女';
          }
      },
      userStatusFormatter(data) {
          if (data.status === 1) {
              return '正常';
          }
          if (data.status === 3) {
              return '禁用';
          }
      }
    },
    created(){
        this.onSubmit();
    }
}
</script>



// WEBPACK FOOTER //
// src/page/user/clientUserInfo.vue